/* ••[1]••••••••••••••••••••••••• VanillaTipsProvider.ts •••••••••••••••••••••••••••••• */

import VanillaProvider from "./VanillaProvider";

import SelectItem from "../../../interfaces/SelectItem";

import FetchSettings from "../../../interfaces/FetchSettings";

import { VanillaDiscussion } from "./../../../interfaces/VanillaApi";
import Tag from "../../../interfaces/Tag";

export default class VanillaTipsProvider extends VanillaProvider {
  async getCategoryTags(catId: number): Promise<Array<SelectItem>> {
    const parentTag = await this.getTags(["query=Category " + catId]);
    return parentTag.length > 0
      ? this.getTags(["parentID=" + parentTag[0].id])
      : [];
  }

  public async getTips(tag: Tag, limit = 5): Promise<Array<VanillaDiscussion>> {
    //community.oracle.com/ccc/api/v2/tags?query=Tip&parentID=133
    const url = new URL(this.baseUrl + "search");
    const searchParams = new URLSearchParams();
    searchParams.append("page", "1");
    searchParams.append("limit", limit.toString());
    // searchParams.append("sort", "-dateInserted");
    searchParams.append("recordTypes[]", "discussion");
    // searchParams.append("types[]", "discussion");
    searchParams.append("tags[]", tag.urlCode);
    searchParams.append("tagOperator", "and");
    url.search = new URLSearchParams(searchParams).toString();
    const settings: FetchSettings = {
      method: "GET",
    };
    return await this.request(url.toString(), settings);
  }

  async lookupForTipTag(parentTagId: number): Promise<Tag | null> {
    const tags = await this.getTags(["query=Tip", "parentID=" + parentTagId]);
    if (tags.length > 0) {
      const tipTag = tags.filter((tag) => tag.name === "Tip");

      return tipTag.length > 0 ? tipTag[0] : null;
    }

    return null;
  }
}
